import { JsonBlock } from '@/components/runs/JsonBlock';
import { Section } from '@/components/runs/Section';

export function InputSection({ input }: { input: unknown[] | null }) {
  if (!input || input.length === 0) {
    return (
      <Section label="Input" tone="neutral">
        <p className="text-xs italic text-muted-foreground">No arguments.</p>
      </Section>
    );
  }
  if (input.length === 1) {
    return (
      <Section label="Input" tone="neutral">
        <JsonBlock value={input[0]} />
      </Section>
    );
  }
  return (
    <Section label={`Input (${input.length} args)`} tone="neutral">
      <div className="space-y-2">
        {input.map((arg, i) => (
          <div key={i}>
            <p className="mb-1 text-[11px] uppercase tracking-wider text-muted-foreground">
              arg {i}
            </p>
            <JsonBlock value={arg} />
          </div>
        ))}
      </div>
    </Section>
  );
}
